import { render, staticRenderFns } from "./ErrorIndicator.vue?vue&type=template&id=386bd0ea&scoped=true&"
import script from "./ErrorIndicator.vue?vue&type=script&lang=js&"
export * from "./ErrorIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ErrorIndicator.vue?vue&type=style&index=0&id=386bd0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386bd0ea",
  null
  
)

export default component.exports